Namespace 'Customer.Views.Activity'

class Customer.Views.Activity.HeaderView extends Backbone.View
  template: JST['backbone/templates/customer/activity/content_type_filter/header']
  className: 'content-type-header'

  initialize: (@socialNetwork, @isSelected) ->

  render: ->
    socialNetworkTranslation = @_socialNetworkTranslation()
    @$el.html(@template({
      inputId: "checkbox-input-#{@socialNetwork}",
      labelId: "checkbox-for-#{@socialNetwork}",
      socialNetwork: @socialNetwork,
      label: socialNetworkTranslation.charAt(0).toUpperCase() + socialNetworkTranslation.slice(1),
      checked: if @isSelected then 'checked' else ''
    }))
    @

  _socialNetworkTranslation: ->
    return @socialNetwork if @socialNetwork != 'other'
    return I18n.t('customer.reports.activity_report.header.other')
